import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const roleHome = (role) => role === "admin" ? "/admin" : role === "inspector" ? "/inspector" : (role === "seller" || role === "dealer") ? "/seller" : "/buyer";

export default function AuthCallback() {
  const { emergentSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        const u = await emergentSession(m[1]);
        // clean the hash
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Signed in as ${u.name}`);
        navigate(roleHome(u.role));
      } catch (e) {
        toast.error("Google sign-in failed");
        navigate("/login");
      }
    })();
  }, [emergentSession, navigate]);

  return <div className="p-10 text-sm text-muted-foreground">Completing sign-in…</div>;
}
